import { productCountStyles as styles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { css } from "styled-components";

styles.wrapper = {
    ...styles.wrapper,
    css: css`
        ${styles.wrapper?.css}
        margin: 0;
        display: flex;
        gap: 5px;
    `,
};

styles.countText = {
    ...styles.countText,
    variant: "h4",
    css: css`
        margin: 0;
    `,
};

styles.itemsText = {
    ...styles.itemsText,
    variant: "h4",
    css: css`
        margin: 0;
    `,
};
